(function () {
    'use strict';
    var controllerId = 'pacchettoTestAdd';
    angular.module('app').controller(controllerId, ['$scope', '$timeout', 'datacontext', '$translate', '$uibModal', '$uibModalInstance', '_', 'pacchettoId', 'test', 'testId', pacchettoTestAddFn]);

    function pacchettoTestAddFn($scope, $timeout, datacontext, $translate, $uibModal, $uibModalInstance, _, pacchettoId, test, testId) {
        $scope.pacchettoTest = {};    
        $scope.tests = [];
        $scope.fSelectNum = 5;
        $scope.test = test;
        $scope.countCheck = 0;

        if (pacchettoId) {
            $scope.pacchettoTest.PacchettoId = pacchettoId;
        }

        if (testId) {
            $scope.testId = testId;
            $scope.pacchettoTest.TestId = testId;
        }

        $scope.list = {};
        $scope.list.materie = [];
        $scope.list.argomenti = [];
        $scope.list.anni = [{ 'id': 1, 'label': $translate.instant('PrimoBiennio') }, { 'id': 2, 'label': $translate.instant('SecondoBiennio') }, { 'id': 5, 'label': $translate.instant('QuintoAnno') }];

        $scope.item = {};
        $scope.item.fTesto = '';
        $scope.item.cerca = getListTests;
        $scope.selectRandomItem = selectRandomItem;    
        $scope.countCheckbox = countCheckbox;
        $scope.stampaTest = stampaTest;
        
        $scope.materie = [];
        $scope.argomenti = [];
        $scope.anni = [];    
        
        $scope.multiselectSettings = {
            smartButtonMaxItems: 4,
            smartButtonTextConverter: function (itemText, originalItem) { return itemText; },
            scrollableHeight: '200px',
            //scrollable: true,
            enableSearch: true
        };
        
        getMaterie();
        getArgomenti();
        getListTests();

        $scope.ok = function (isValid) {
        	if (isValid) {
        		var testsList = [];
        		$("input:checkbox[name=testId]:checked").each(function () {
        				testsList.push($(this).val());
        			});
                var result = addItem($scope.pacchettoTest.PacchettoId, testsList);
                $uibModalInstance.close(result);
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.toggleAll = function () {
            if ($scope.isAllSelected) {
                $("input:checkbox[name=testId]").each(function () {
                    this.checked = true;
                });
            } else {
                $("input:checkbox[name=testId]").each(function () {
                    this.checked = false;
                });
            }
            countCheckbox();
        };

        function addItem(pacchettoId, testsList) {
            return datacontext.pacchettoTest_importList(pacchettoId, testsList).then(function (data) {
                if (!data) return null;

                return data;
            });
        }

        function getArgomenti() {
            return datacontext.argomenti_getAll(0, 0, '').then(function (data) {
                if (data) {
                    data.forEach(function (item) {
                        var obj = { 'id': item, 'label': item.charAt(0).toUpperCase() + item.slice(1) };
                        $scope.list.argomenti.push(obj);
                    });
                }
            });
        }

        function getMaterie() {
            return datacontext.stak_materia_getAllList().then(function (data) {
                if (data) {
                    data.forEach(function (item) {
                        var obj = { 'id': item.Id, 'label': item.Name };
                        $scope.list.materie.push(obj);
                    });
                }
            });
        }

        function getListTests() {
            $scope.tests = [];
            var materie = [];
            var argomenti = [];
            var anni = [];

            if ($scope.materie.length > 0) {
                $scope.materie.forEach(function (m) {
                    materie.push(m.id);
                });
            }

            if ($scope.argomenti.length > 0) {
                $scope.argomenti.forEach(function (m) {
                    argomenti.push(m.id);
                });
            }

            if ($scope.anni.length > 0) {
                $scope.anni.forEach(function (m) {
                    anni.push(m.id);
                });
            }

            return datacontext.stak_testNotInPacchetto_getAllByFilter(materie, argomenti, anni, pacchettoId).then(function (data) {
                if (data) {
                    $scope.tests = data;
                    $timeout(function () {
                        $("button[name=selection]").trigger('click');
                        countCheckbox();
                    }, 300);
                    return $scope.tests;
                }   
            });
        }

        function countCheckbox() {
            $scope.countCheck = $("input:checkbox[name=testId]:checked").length;
        }

        function getRandomArrayElements(arr, count) {
            var randoms = [], clone = arr.slice(0);
            var index = 0;

            for (var i = 0; i < count; i++) {
                index = Math.floor(Math.random() * clone.length);
                var checkIndex = _.findIndex(randoms, function (r) {
                    return r === clone[index];
                });

                if (checkIndex == -1) {
                    randoms.push(clone[index]);
                    clone[index] = clone.pop();
                } else {
                    while (checkIndex != -1) {
                        index = Math.floor(Math.random() * clone.length);
                        checkIndex = _.findIndex(randoms, function (r) {
                            return r === clone[index];
                        });
                        if (checkIndex == -1) {
                            randoms.push(clone[index]);
                            clone[index] = clone.pop();
                        }
                    }
                }
            }
            return randoms;
        }

        //Dummy array
        function createArray(c) {
            var ar = [];
            for (var i = 0; i < c; i++) {
                ar.push(i);
            }
            return ar;
        }

        //check random checkboxes
        function checkRandom(r, nodeList) {
            for (var i = 0; i <= r.length; i++) {
                nodeList.get(r[i]).checked = true;
            }
        }

        function selectRandomItem(number) {
            var check = $("input[type=checkbox]");
            check.attr("checked", false);

            check = $("input:checkbox[name=testId]");

            var a = createArray($scope.tests.length);

            if (number > $scope.tests.length)
                number = $scope.tests.length;

            var r = getRandomArrayElements(a, number);

            checkRandom(r, check);
            if (number >= $scope.tests.length)
                $scope.isAllSelected = true;
            else
                $scope.isAllSelected = false;

            countCheckbox();
        }

        function stampaTest(testId) {
            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: "/app/STAK_Test/modal/stampaTest.html?version=43",
                controller: "stampaTestStak",
                windowClass: 'modal-wide-print',
                resolve: {
                    testId: function () {
                        return testId;
                    }
                }
            });
        }

    }
})();